<template>
  <CustomModal ref="signaturebusinessmodal" class="signature-business-modal" title="Signature">
    <div v-if="business && business.signature.name" class="signature-container">
      <p><strong>Date de signature : </strong>{{business.signature.signedAt}}</p>
      <p><strong>Email : </strong>{{business.signature.email}}</p>
      <p><strong>Nom : </strong>{{business.signature.name}}</p>
      <p><strong>Pays : </strong>{{business.signature.country}}</p>
      <p><strong>Région : </strong>{{business.signature.region}}</p>
      <p><strong>Ville : </strong>{{business.signature.city}}</p>
      <p><strong>UserAgent : </strong> <span class="question">donnée privé<span title="Cette donée est privée, pour l'obtenir raprochez-vous d'un modérateur" class="fas fa-circle-question"></span></span></p>
      <p><strong>IP : </strong> <span class="question">donnée privé<span title="Cette donée est privée, pour l'obtenir raprochez-vous d'un modérateur" class="fas fa-circle-question"></span></span></p>
      <p><strong>Hash : </strong> <span class="question">donnée privé<span title="Cette donée est privée, pour l'obtenir raprochez-vous d'un modérateur" class="fas fa-circle-question"></span></span></p>
    </div>
    <div v-if="business && business.signature.artificiallyValidate" class="signature-container">
      <p>Signature validée par un administrateur ou un modérateur à date du {{business.signature.signedAt}}.</p>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import CustomModal from "@/components/modals/CustomModal.vue";
library.add(faQuestion);

  export default {
      name: 'SignatureBusinessModal',
      components: {CustomModal},
      data() {
          return {
            business: undefined,
            buttons:{
              back: {text: "Retour"},
            },
            isTerminateButtonDisplayed: false
          };
      },
      methods: {
        openModal(business) {
          this.$refs.signaturebusinessmodal.openModal();
          this.business = business;
        }
      }
  }

</script>

<style lang="stylus">
  .signature-business-modal .modal
    width 100% !important
    max-width 500px !important
</style>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    .separator
      margin-top 15px
      height 2px
      background-color THEME_COLOR_PRIMARY_FADDED
      opacity 0.6

    .state-container
      display flex
      flex-direction column
      margin-top 30px
      .waring
        border solid 2px #ffd78e
        background-color #fff6e6
        color #553900
        padding 10px
        margin-bottom 15px
      .separator-state-container
        width 30px
    .signature-container
      p
        display flex
        justify-content space-between
        margin-top 5px
        margin-bottom 5px
        .question
          display flex
          gap 5px
          cursor pointer
</style>
